import styled from 'styled-components';

export const ContractTermsTableSection = styled.section`
  margin-bottom: 1.25rem;

  .ant-tag {
    margin: 0.15rem;
  }
`;
